import { getDefaultOutputKey } from '../components/Dashboard/controlRegistry';

/**
 * Map app/v2 definition panels to legacy DashboardLayout / DashboardPanel shape.
 */
export function v2AppToDashboardConfig(def, opts = {}) {
  if (!def || typeof def !== 'object') return { layout: 'three-panel', chatPosition: 'center', panels: [] };
  const panels = (Array.isArray(def.panels) ? def.panels : []).map((p) => {
    const flowRef = p.source?.flowRef || p.flowId || p.flow_id;
    const outputKey = p.outputKey || (p.componentType ? getDefaultOutputKey(p.componentType) : undefined);
    return {
      ...p,
      flowId: flowRef || undefined,
      outputKey,
      config: p.config && typeof p.config === 'object' ? p.config : {},
    };
  });
  return {
    id: opts.mongoId || def.id,
    _id: opts.mongoId || def.id,
    definitionId: def.id,
    runtimeSource: 'v2app',
    layout: def.layout || 'three-panel',
    gridLayout: Array.isArray(def.gridLayout) ? def.gridLayout : null,
    chatPosition: def.chatPosition || 'center',
    theme: def.theme,
    name: def.name,
    description: def.description,
    panels,
    metadata: def.metadata && typeof def.metadata === 'object' ? def.metadata : {},
    defaultFlowId: def.defaultFlowId || def.metadata?.interviewFlow?.defaultChatFlowRef || null,
    default_flow_id: def.defaultFlowId || def.metadata?.interviewFlow?.defaultChatFlowRef || null,
    studioPreviewInterview: opts.studioPreview === true,
    demoReadOnly: opts.demoReadOnly === true,
    citizenMode: opts.citizenMode === true
      || def.metadata?.interviewFlow?.citizenMode === true,
    ...(Array.isArray(opts.pluginPanels) ? { pluginPanels: opts.pluginPanels } : {}),
  };
}
